<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm">
    <!-- 背景装饰 -->
    <div class="absolute inset-0 pointer-events-none overflow-hidden">
      <div class="absolute top-20 left-10 w-16 h-16 sm:w-24 sm:h-24 md:w-32 md:h-32 bg-psychology-primary-20 rounded-full blur-xl"></div>
      <div class="absolute top-40 right-16 w-12 h-12 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-yellow-200/20 rounded-full blur-lg"></div>
      <div class="absolute bottom-32 left-1/3 w-20 h-20 sm:w-32 sm:h-32 md:w-40 md:h-40 bg-orange-200/20 rounded-full blur-xl"></div>
    </div>

    <!-- 导航栏 -->
    <NavBar />

    <!-- 主要内容 -->
    <div class="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 md:py-12">
      <!-- 页面标题 -->
      <div class="text-center mb-8 sm:mb-10 md:mb-12">
        <div class="text-4xl sm:text-5xl md:text-6xl mb-4 sm:mb-5 md:mb-6">💕</div>
        <h1 class="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">使用指南</h1>
        <p class="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto px-2">
          通过40道科学问题，了解你的年上年下恋爱倾向和依恋类型
        </p>
      </div>

      <div class="space-y-6 sm:space-y-8">
        <!-- 快速开始 -->
        <div class="card">
          <div class="p-4 sm:p-5 md:p-6">
            <div class="text-xl sm:text-2xl font-semibold flex items-center gap-2 sm:gap-3 mb-4 sm:mb-5 md:mb-6">
              <span class="text-2xl sm:text-3xl">🚀</span>
              <span>快速开始</span>
            </div>
            
            <div class="bg-gradient-to-r from-psychology-calm to-psychology-warm rounded-lg p-4 sm:p-5 md:p-6 border border-psychology-primary-20">
              <div class="space-y-3 sm:space-y-4">
                <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
                  <div class="inline-flex items-center rounded-full border px-2.5 sm:px-3 py-1 text-xs sm:text-sm font-semibold bg-psychology-primary-10 text-psychology-primary border-psychology-primary-20 whitespace-nowrap self-start">
                    ⏱️ 预计耗时
                  </div>
                  <span class="text-sm sm:text-base text-gray-700">8-12 分钟</span>
                </div>
                <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
                  <div class="inline-flex items-center rounded-full border px-2.5 sm:px-3 py-1 text-xs sm:text-sm font-semibold bg-yellow-100 text-yellow-700 border-yellow-200 whitespace-nowrap self-start">
                    📝 题目数量
                  </div>
                  <span class="text-sm sm:text-base text-gray-700 break-words">40 道评分题(4维度×10题)</span>
                </div>
                <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
                  <div class="inline-flex items-center rounded-full border px-2.5 sm:px-3 py-1 text-xs sm:text-sm font-semibold bg-psychology-primary-10 text-psychology-primary border-psychology-primary-20 whitespace-nowrap self-start">
                    🎯 测试结果
                  </div>
                  <span class="text-sm sm:text-base text-gray-700 break-words">AYP指数+5种人格类型+4种依恋类型</span>
                </div>
                <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
                  <div class="inline-flex items-center rounded-full border px-2.5 sm:px-3 py-1 text-xs sm:text-sm font-semibold bg-pink-100 text-pink-700 border-pink-200 whitespace-nowrap self-start">
                    💡 答题方式
                  </div>
                  <span class="text-sm sm:text-base text-gray-700 break-words">1-5级评分，根据真实感受打分</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 测评流程 -->
        <div class="card">
          <div class="p-4 sm:p-5 md:p-6">
            <div class="text-xl sm:text-2xl font-semibold flex items-center gap-2 sm:gap-3 mb-4 sm:mb-5 md:mb-6">
              <span class="text-2xl sm:text-3xl">📋</span>
              <span>测试流程</span>
            </div>

            <div class="space-y-3 sm:space-y-4">
              <!-- 步骤1 -->
              <div class="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-psychology-primary-10 rounded-lg border border-psychology-primary-20">
                <div class="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-psychology-primary to-psychology-secondary text-white rounded-full flex items-center justify-center text-base sm:text-lg font-semibold">
                  1
                </div>
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-xl sm:text-2xl flex-shrink-0">📝</span>
                    <h4 class="font-semibold text-sm sm:text-base text-gray-900">开始测试</h4>
                  </div>
                  <p class="text-xs sm:text-sm text-gray-600">点击"开始测试"按钮，阅读简单的测试说明</p>
                </div>
              </div>

              <!-- 步骤2 -->
              <div class="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-yellow-50 rounded-lg border border-yellow-200">
                <div class="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-yellow-500 to-orange-500 text-white rounded-full flex items-center justify-center text-base sm:text-lg font-semibold">
                  2
                </div>
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-xl sm:text-2xl flex-shrink-0">👤</span>
                    <h4 class="font-semibold text-sm sm:text-base text-gray-900 break-words">选择测试类型和基本信息</h4>
                  </div>
                  <p class="text-xs sm:text-sm text-gray-600">选择测试类型(给自己/为恋人)、年龄段和星座</p>
                </div>
              </div>

              <!-- 步骤3 -->
              <div class="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-psychology-primary-10 rounded-lg border border-psychology-primary-20">
                <div class="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-psychology-primary to-psychology-info text-white rounded-full flex items-center justify-center text-base sm:text-lg font-semibold">
                  3
                </div>
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-xl sm:text-2xl flex-shrink-0">✍️</span>
                    <h4 class="font-semibold text-sm sm:text-base text-gray-900">答题</h4>
                  </div>
                  <p class="text-xs sm:text-sm text-gray-600">回答40道问题，每题使用1-5级评分(1=完全不符合，5=完全符合)</p>
                </div>
              </div>

              <!-- 步骤4 -->
              <div class="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-pink-50 rounded-lg border border-pink-200">
                <div class="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-pink-600 to-purple-600 text-white rounded-full flex items-center justify-center text-base sm:text-lg font-semibold">
                  4
                </div>
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-xl sm:text-2xl flex-shrink-0">🔍</span>
                    <h4 class="font-semibold text-sm sm:text-base text-gray-900">查看结果</h4>
                  </div>
                  <p class="text-xs sm:text-sm text-gray-600">获得AYP指数、恋爱人格类型、依恋类型和星座分析报告</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 答题建议 -->
        <div class="card">
          <div class="p-4 sm:p-5 md:p-6">
            <div class="text-xl sm:text-2xl font-semibold flex items-center gap-2 sm:gap-3 mb-4 sm:mb-5 md:mb-6">
              <span class="text-2xl sm:text-3xl">💡</span>
              <span>答题建议</span>
            </div>

            <div class="grid gap-3 sm:gap-4">
              <div class="flex items-start gap-2 sm:gap-3 p-3 sm:p-4 border border-purple-200 rounded-lg bg-purple-50/50">
                <span class="text-xl sm:text-2xl flex-shrink-0">✨</span>
                <div class="min-w-0">
                  <h4 class="font-medium text-sm sm:text-base text-gray-900 mb-1">根据真实感受评分</h4>
                  <p class="text-xs sm:text-sm text-gray-600">不要想"应该"怎样，而是想你"实际上"怎样</p>
                </div>
              </div>

              <div class="flex items-start gap-2 sm:gap-3 p-3 sm:p-4 border border-psychology-info-20 rounded-lg bg-psychology-info-10">
                <span class="text-xl sm:text-2xl flex-shrink-0">🎭</span>
                <div class="min-w-0">
                  <h4 class="font-medium text-sm sm:text-base text-gray-900 mb-1">诚实作答</h4>
                  <p class="text-xs sm:text-sm text-gray-600">选择最符合你真实情况的评分，没有对错之分</p>
                </div>
              </div>

              <div class="flex items-start gap-2 sm:gap-3 p-3 sm:p-4 border border-psychology-primary-20 rounded-lg bg-psychology-primary-10">
                <span class="text-xl sm:text-2xl flex-shrink-0">⏱️</span>
                <div class="min-w-0">
                  <h4 class="font-medium text-sm sm:text-base text-gray-900 mb-1">保持专注</h4>
                  <p class="text-xs sm:text-sm text-gray-600">在安静、不被打扰的环境中完成测试，确保可以专注思考</p>
                </div>
              </div>

              <div class="flex items-start gap-2 sm:gap-3 p-3 sm:p-4 border border-pink-200 rounded-lg bg-pink-50/50">
                <span class="text-xl sm:text-2xl flex-shrink-0">🔄</span>
                <div class="min-w-0">
                  <h4 class="font-medium text-sm sm:text-base text-gray-900 mb-1">进度自动保存</h4>
                  <p class="text-xs sm:text-sm text-gray-600">答题过程中可以返回修改，进度会自动保存，可随时继续</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 测试说明 -->
        <div class="card border-yellow-200 bg-yellow-50/30">
          <div class="p-4 sm:p-5 md:p-6">
            <div class="text-xl sm:text-2xl font-semibold flex items-center gap-2 sm:gap-3 mb-4 sm:mb-5 md:mb-6 text-yellow-800">
              <span class="text-2xl sm:text-3xl">⚠️</span>
              <span>重要说明</span>
            </div>

            <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-3 sm:p-4">
              <div class="space-y-2.5 sm:space-y-3 text-xs sm:text-sm">
                <div class="flex items-start gap-2">
                  <span class="text-yellow-600 mt-0.5 sm:mt-1 flex-shrink-0">•</span>
                  <span class="text-gray-700"><strong>趣味测试：</strong>这是一个有趣的性格测试，仅供娱乐和自我了解，不能替代专业的心理评估</span>
                </div>
                <div class="flex items-start gap-2">
                  <span class="text-yellow-600 mt-0.5 sm:mt-1 flex-shrink-0">•</span>
                  <span class="text-gray-700"><strong>隐私保护：</strong>所有数据仅存储在您的设备本地，不会上传到任何服务器</span>
                </div>
                <div class="flex items-start gap-2">
                  <span class="text-yellow-600 mt-0.5 sm:mt-1 flex-shrink-0">•</span>
                  <span class="text-gray-700"><strong>结果解读：</strong>测试结果基于4个维度的科学计算，每个人都是独特的，结果仅供参考</span>
                </div>
                <div class="flex items-start gap-2">
                  <span class="text-yellow-600 mt-0.5 sm:mt-1 flex-shrink-0">•</span>
                  <span class="text-gray-700"><strong>多次测试：</strong>可以多次测试，不同时间、不同心情可能会得到不同的结果</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 结果解读 -->
        <div class="card">
          <div class="p-4 sm:p-5 md:p-6">
            <div class="text-xl sm:text-2xl font-semibold flex items-center gap-2 sm:gap-3 mb-4 sm:mb-5 md:mb-6">
              <span class="text-2xl sm:text-3xl">🎯</span>
              <span>结果解读</span>
            </div>

            <div class="space-y-4 sm:space-y-6">
              <!-- 4个维度 -->
              <div>
                <h4 class="font-semibold text-sm sm:text-base text-gray-900 mb-2 sm:mb-3">4个恋爱倾向维度</h4>
                <p class="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-3">测试通过以下4个维度来分析你的恋爱倾向：</p>
                <div class="grid sm:grid-cols-2 gap-2.5 sm:gap-3 text-xs sm:text-sm">
                  <div class="p-2.5 sm:p-3 bg-red-50 rounded border border-red-200">
                    <div class="font-medium text-gray-900 mb-1 text-xs sm:text-sm">成熟偏好 (MAT)</div>
                    <div class="text-gray-600 text-xs">对伴侣成熟度的偏好程度</div>
                  </div>
                  <div class="p-2.5 sm:p-3 bg-purple-50 rounded border border-purple-200">
                    <div class="font-medium text-gray-900 mb-1 text-xs sm:text-sm">照顾需求 (CAR)</div>
                    <div class="text-gray-600 text-xs">被照顾的需求强度</div>
                  </div>
                  <div class="p-2.5 sm:p-3 bg-amber-50 rounded border border-amber-200">
                    <div class="font-medium text-gray-900 mb-1 text-xs sm:text-sm">引导欲望 (GUI)</div>
                    <div class="text-gray-600 text-xs">引导和照顾对方的欲望</div>
                  </div>
                  <div class="p-2.5 sm:p-3 bg-cyan-50 rounded border border-cyan-200">
                    <div class="font-medium text-gray-900 mb-1 text-xs sm:text-sm">独立倾向 (IND)</div>
                    <div class="text-gray-600 text-xs">保持独立性的需求</div>
                  </div>
                </div>
              </div>

              <div class="border-t border-gray-200 my-3 sm:my-4"></div>

              <!-- 结果内容 -->
              <div>
                <h4 class="font-semibold text-sm sm:text-base text-gray-900 mb-2 sm:mb-3">结果包含</h4>
                <div class="space-y-1.5 sm:space-y-2 text-xs sm:text-sm text-gray-600">
                  <div class="flex items-start gap-2">
                    <span class="text-purple-600 flex-shrink-0 mt-0.5">✓</span>
                    <span>AYP指数（-100到+100）</span>
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="text-psychology-info flex-shrink-0 mt-0.5">✓</span>
                    <span>5种恋爱人格类型（极度年上型、偏年上型、平衡型、偏年下型、极度年下型）</span>
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="text-psychology-primary flex-shrink-0 mt-0.5">✓</span>
                    <span>4种依恋类型（安全型、焦虑型、回避型、混乱型）</span>
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="text-pink-600 flex-shrink-0 mt-0.5">✓</span>
                    <span>四维度雷达图可视化</span>
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="text-yellow-600 flex-shrink-0 mt-0.5">✓</span>
                    <span>星座分析与个性化建议</span>
                  </div>
                  <div class="flex items-start gap-2">
                    <span class="text-indigo-600 flex-shrink-0 mt-0.5">✓</span>
                    <span>详细的心理学解读和改善建议</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CTA按钮 -->
        <div class="max-w-3xl mx-auto bg-gradient-to-r from-psychology-primary to-psychology-secondary rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-12 text-white shadow-2xl">
          <div class="text-center">
            <div class="text-4xl sm:text-5xl md:text-6xl mb-4 sm:mb-5 md:mb-6">💕</div>
            <h3 class="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 px-2">准备发现你的恋爱倾向了吗？</h3>
            <p class="text-sm sm:text-base md:text-lg mb-6 sm:mb-7 md:mb-8 opacity-90 max-w-2xl mx-auto px-2">
              通过科学的四维度心理学模型，精准评估你的年上年下倾向，深入了解你的恋爱人格和依恋模式
            </p>
            <router-link
              to="/assessment/select-type"
              class="inline-flex items-center gap-2 px-6 sm:px-7 md:px-8 py-3 sm:py-3.5 md:py-4 bg-white text-psychology-primary rounded-lg font-bold text-base sm:text-lg hover:bg-gray-100 transition-all hover:shadow-xl"
            >
              <span class="text-xl sm:text-2xl">💝</span>
              <span>开始测试</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" class="sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 回到顶部 -->
    <BackToTop />
  </div>
</template>

<script setup>
import NavBar from '../components/NavBar.vue'
import BackToTop from '../components/BackToTop.vue'
</script>

<style scoped>
.card {
  @apply bg-white rounded-xl shadow-md border border-gray-200;
}
</style>